<template>
    <tw-modal ref="modal-cover-disclamer" ok-text="Confirm" @cancel="cancel" @ok="confirm" :manual-close="true"
        :ok-busy="isLoading">
        <template v-slot:header>
            Important Information
        </template>


        <template #body>


            <h3 class="text-lg mb-3 font-medium text-center">
                {{ currentRule?.title }}
            </h3>

            <div v-show="currentRule?.code === 'is_electric'">


                <h4 class="my-4 text-center  text-gray-600">
                    We cover electrically assisted pedal cycles as follows:
                </h4>
                <ul class="list-disc pl-8 space-y-4">
                    <li>
                        The bike must not have been built from an ebike conversion kit (e.g. not fitted with a battery
                        after
                        purchase)
                    </li>
                    <li>
                        It must be fitted with pedals that are capable of propelling it
                    </li>
                    <li>
                        Must have a maximum continuous rated power output of 250 watts
                    </li>
                    <li>
                        Electrical assistance must cut-off at 15.5 miles per hour
                    </li>
                    <li>
                        Is not a moped-style bike with a step-through footplate nor an electric scooter
                    </li>
                </ul>
            </div>


            <div v-show="currentRule?.code === 'purchase_type_new'">

                <ul class="list-disc pl-8 space-y-4">
                    <li>
                        Must be insured at the price you paid, including the sum of any parts or upgrades which form
                        part of
                        your bicycle
                    </li>
                    <li>
                        Discounted bicycle(s) should be valued at the original undiscounted RRP at the purchase date
                    </li>
                    <li>
                        Evidence of ownership can include the original purchase receipt or invoice from a reputable
                        retailer
                        or manufacturer or any other evidence, which clearly demonstrates ownership
                    </li>

                </ul>
            </div>

            <div v-show="currentRule?.code === 'purchase_type_secondhand'">
                <ul class="list-disc pl-8 space-y-4">
                    <li>
                        Must be insured at the price you paid, including the sum of any parts or upgrades which form
                        part of
                        your bicycle
                    </li>
                    <li>
                        Evidence of ownership can include the original purchase receipt or invoice from a reputable
                        retailer
                        or manufacturer or any other evidence, which clearly demonstrates ownership
                    </li>
                    <li>
                        We do not cover secondhand bicycles purchased from private sellers where payment was made by
                        cash
                        and where there is no receipt or invoice from a reputable retailer or seller.
                    </li>
                </ul>
            </div>

            <nav v-if="rules.length > 1" class="flex items-center justify-center py-4" aria-label="Progress">
                <p class="text-gray-500 text-sm">Step {{ currentStep + 1 }} of {{ rules.length }}</p>
                <ol role="list" class="ml-8 flex items-center space-x-5">
                    <li v-for="(rule, index) in rules" :key="rule.code">
                        <a v-if="currentStep > index" class="block h-2.5 w-2.5 rounded-full bg-primary hover:bg-teal-200">
                            <span class="sr-only">{{ rule.title }}</span>
                        </a>
                        <a v-else-if="currentStep === index" class="relative flex items-center justify-center"
                            aria-current="step">
                            <span class="absolute flex h-5 w-5 p-px" aria-hidden="true">
                                <span class="h-full w-full rounded-full bg-teal-50" />
                            </span>
                            <span class="relative block h-2.5 w-2.5 rounded-full bg-primary" aria-hidden="true" />
                            <span class="sr-only">{{ rule.title }}</span>
                        </a>
                        <a v-else class="block h-2.5 w-2.5 rounded-full bg-gray-200">
                            <span class="sr-only">{{ rule.title }}</span>
                        </a>
                    </li>
                </ol>
            </nav>

        </template>

    </tw-modal>
</template>

<script>
export default {
    props: {

    },
    data: () => ({
        resolvePromise: undefined,
        form: null,
        rules: [],
        currentStep: null,
        isLoading: false,
    }),
    computed: {
        currentRule() {
            if (this.rules.length === 0 || this.currentStep == null) {
                return null;
            }

            return this.rules.find((rule, index) => index === this.currentStep);
        }
    },
    watch: {

    },
    methods: {
        open(options = {}) {
            this.form = options.form;

            this.currentStep = null;
            this.rules = [];

            if (this.form.is_electric === true) {
                this.rules.push({
                    title: 'E-Bike Requirements',
                    code: 'is_electric',
                });
            }
            if (this.form.purchase_type === 'new') {
                this.rules.push({
                    title: 'New Bikes',
                    code: 'purchase_type_new',
                });
            }
            if (this.form.purchase_type === 'secondhand') {
                this.rules.push({
                    title: 'Secondhand Bikes',
                    code: 'purchase_type_secondhand',
                });
            }


            if (this.rules.length === 0) {
                return new Promise((resolve, reject) => {
                    resolve(true);
                });
            }

            this.currentStep = 0;

            this.$refs['modal-cover-disclamer'].open();

            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
            })
        },

        confirm() {
            this.isLoading = true;

            setTimeout(() => {
                if (this.currentStep < (this.rules.length - 1)) {
                    this.isLoading = false;
                    this.currentStep++;
                    return;
                }

                this.$refs['modal-cover-disclamer'].close()
                this.resolvePromise(true)
                this.isLoading = false;
            }, 400);
        },

        cancel() {
            this.$refs['modal-cover-disclamer'].close()
            this.resolvePromise(false)


        },
    }
}
</script>